import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { fetchAuthSession } from "@aws-amplify/auth";
import { environment } from "src/environments/environment";

export const loginGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);

  // Check local auth tokens when useLocalAuth is enabled
  if (environment.useLocalAuth) {
    const localToken = localStorage.getItem("local_access_token");
    if (localToken) {
      return true;
    }
    router.navigate(["/auth"]);
    return false;
  }

  // Default: Check Cognito session
  try {
    const session = await fetchAuthSession({ forceRefresh: false });

    // If we have access token → user is authenticated
    if (session.tokens?.accessToken) {
      return true;
    }
  } catch (error) {
    // Any error means not authenticated (including no session)
    console.log("Not authenticated:", error);
  }
  router.navigate(["/auth"]);
  return false;
};
